import script from "./InputCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./InputCustomer.vue?vue&type=script&setup=true&lang=js"

import "./InputCustomer.vue?vue&type=style&index=0&id=66a83e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4c70acdb4c746897c15f9d0e9400da56/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a83e60"]])

export default __exports__